export interface RegressionPoint {
  ts: number;
  M: number;
  a: number;
}

export const table6_1: RegressionPoint[] = [
  { ts: 7, M: 100.0, a: 60.0 },
  { ts: 8, M: 99.0, a: 62.5 },
  { ts: 9, M: 98.0, a: 65.0 },
  { ts: 10, M: 97.0, a: 67.5 },
  { ts: 11, M: 96.0, a: 70.0 },
  { ts: 12, M: 95.0, a: 72.5 },
  { ts: 13, M: 94.0, a: 75.0 },
  { ts: 14, M: 93.0, a: 77.5 },
  { ts: 15, M: 92.0, a: 80.0 },
  { ts: 16, M: 91.0, a: 82.5 },
  { ts: 17, M: 90.0, a: 85.0 },
  { ts: 18, M: 89.0, a: 87.5 },
  { ts: 19, M: 88.0, a: 90.0 },
  { ts: 20, M: 87.0, a: 92.5 },
  { ts: 21, M: 86.0, a: 95.0 },
  { ts: 22, M: 85.0, a: 97.5 },
  { ts: 23, M: 84.0, a: 100.0 },
  { ts: 24, M: 83.0, a: 102.5 },
  { ts: 25, M: 82.0, a: 105.0 },
  { ts: 26, M: 81.0, a: 107.5 },
  { ts: 27, M: 80.0, a: 110.0 },
  { ts: 28, M: 79.0, a: 112.5 },
  { ts: 29, M: 78.0, a: 115.0 },
  { ts: 30, M: 77.0, a: 117.5 },
  { ts: 31, M: 76.0, a: 120.0 },
  { ts: 32, M: 75.0, a: 122.5 },
  { ts: 33, M: 74.0, a: 125.0 },
  { ts: 34, M: 73.0, a: 127.5 },
  { ts: 35, M: 72.0, a: 130.0 },
  { ts: 36, M: 71.0, a: 132.5 },
  { ts: 37, M: 70.0, a: 135.0 },
  { ts: 38, M: 69.0, a: 137.5 },
  { ts: 39, M: 68.0, a: 140.0 },
  { ts: 40, M: 67.0, a: 142.5 },
];